import {
	getTemplateKeyField,
	TITLE_FIELD,
	IMAGE_FIELD,
	HEADING_FIELD,
	SUBHEADING_FIELD,
	BODY_FIELD_OPTIONAL,
	IMAGE_Y_POSITION_FIELD,
	SECTIONS_FIELD,
	BODY_FIELD,
} from "./fields";

const indexPage = {
	"file": "content/index.md",
	"label": "Home Page",
	"name": "index",
	"fields": [
		getTemplateKeyField("index-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		HEADING_FIELD,
		SUBHEADING_FIELD,
		{
			"label": "Main Quote",
			"name": "mainQuote",
			"widget": "object",
			"fields": [
				{
					"label": "Text",
					"name": "text",
					"widget": "string"
				},
				{
					"label": "Name",
					"name": "name",
					"widget": "string"
				}
			]
		}
	]
};

const blogIndexPage = {
	"file": "content/blog/index.md",
	"label": "Blog Index",
	"name": "blog-index",
	"fields": [
		getTemplateKeyField("blog-index-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		HEADING_FIELD,
		BODY_FIELD_OPTIONAL,
		IMAGE_Y_POSITION_FIELD,
	],
};

const productsIndexPage = {
	"file": "content/products/index.md",
	"label": "Products Index",
	"name": "products-index",
	"fields": [
		getTemplateKeyField("products-index-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		HEADING_FIELD,
		BODY_FIELD_OPTIONAL,
		IMAGE_Y_POSITION_FIELD,
	]
};

const libraryIndexPage = {
	"file": "content/library/index.md",
	"label": "Library Index",
	"name": "library-index",
	"fields": [
		getTemplateKeyField("library-index-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		HEADING_FIELD,
		BODY_FIELD_OPTIONAL,
		IMAGE_Y_POSITION_FIELD,
	]
};

const aboutPage = {
	"file": "content/about/index.md",
	"label": "About",
	"name": "about",
	"fields": [
		getTemplateKeyField("about-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		SECTIONS_FIELD,
		BODY_FIELD,
		IMAGE_Y_POSITION_FIELD,
	]
};

const contactPage = {
	"file": "content/contact/index.md",
	"label": "Contact",
	"name": "contact",
	"fields": [
		getTemplateKeyField("about-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		BODY_FIELD,
		IMAGE_Y_POSITION_FIELD,
	]
};

const servicesPage = {
	"file": "content/services/index.md",
	"label": "Services",
	"name": "services-index",
	"fields": [
		getTemplateKeyField("services-index-page"),
		TITLE_FIELD,
		IMAGE_FIELD,
		SECTIONS_FIELD,
		BODY_FIELD,
		IMAGE_Y_POSITION_FIELD,
	]
};

const filesCollection = {
	"name": "pages",
	"label": "Pages",
	"files": [
		indexPage,
		blogIndexPage,
		productsIndexPage,
		libraryIndexPage,
		aboutPage,
		contactPage,
		servicesPage,
	],
};

export default filesCollection;
